import { v4 as uuidv4 } from 'uuid';

import { isStinvestActiveClient } from '»utils/clientsUtils';

export const initialStore = {
  auth: {
    isAuthenticated: false,
    isLoading: false,
    token: null,
    user: null,
    loginId: null,
    uuid: uuidv4(),
    showLogoutAlert: false,
    loginCurrentStep: 0,
    onboarding: {
      legalStatus: '',
      legalStatusList: [],
      error: '',
      currentStep: isStinvestActiveClient ? 0 : 1,
      mainFormFields: [],
      openingRequestId: '',
      legalStatus: '',
      ibanCode: '',
      ibanCode2: '',
      bankAccountNumber: '',
      holderCode: '',
      shouldShowQuestionnaire: '',
      contract: {
        file: '',
        disclaimer: '',
        isLoading: '',
      },
      documents: {},
      isJoinProcessCompleted: false,
    },
  },
};
